import service from '@/utils/request';


// 获取余额
export function getPointLeft (data) {
  return service({
    url: '/v1/chat/pointLeft',
    method: 'get',
  })
}
// 获取商品列表
export function getList (data) {
  return service({
    url: '/v1/product/list',
    method: 'get',
    params: data
  })
}


// 获取使用记录
export function getUsage (data) {
  return service({
    url: '/v1/chat/usage',
    method: 'get',
    params: data
  })
}

// 诺诺创建订单接口，PC端使用
export function nuonuoCreate (data) {
  return service({
    url: '/v1/orderinfo/nuonuoCreate',
    method: 'post',
    data: data
  })
}


// 诺诺支付
export function getQrImg (data) {
  return service({
    url: '/v1/pay/nuonuo/getQrImg',
    method: 'get',
    params: data
  })
}

// 诺诺处理已支付订单接口
export function dealNuonuoPayedOrder (data) {
  return service({
    url: '/v1/orderinfo/dealNuonuoPayedOrder',
    method: 'post',
    data: data
  })
}

// 使用用户名或者手机查询用户信息
export function getUserInfo (data) {
  return service({
    url: '/v1/user/getUserInfo',
    method: 'post',
    data: data
  })
}


// 管理员为其它账号增加AI豆记录
export function admAddPoint (data) {
  return service({
    url: '/v1/chat/admAddPoint',
    method: 'post',
    data: data
  })
}


// 管理员为其它账号已经增加的AI豆记录列表
export function getAdmUsageRecords (data) {
  return service({
    url: '/v1/chat/getAdmUsageRecords',
    method: 'get',
    params: data
  })
}

